export const registrationEventId = 5;
export const reservationType = "slot";
